import { Outlet } from 'react-router';
import useGlobalDataFetcherListener from '../../hooks/global-reducer/useGlobalDataFetcherListener';
import useCrmOrgFromUrl from '../../hooks/useCrmOrgFromUrl';

const AppInitialized = () => {
  //Here goes initializations that DO require "crmOrgs" or "hubspot" to be initialized:
  useGlobalDataFetcherListener();

  useCrmOrgFromUrl();

  //Child routes are defined in AppRoutes.tsx //
  return <Outlet />;
};

export default AppInitialized;
